export const WeddingContractTypesEnum = {
    EMAIL_BANK: 'EMAIL_BANK',
    PRESENCIAL_MONEY: 'PRESENCIAL_MONEY'
}

export const weddingContractTypes = [
    { _id: WeddingContractTypesEnum.EMAIL_BANK, name: 'EMAIL_BANK_CONTRACT', deprecated: false },
    { _id: WeddingContractTypesEnum.PRESENCIAL_MONEY, name: 'PRESENCIAL_MONEY_CONTRACT', deprecated: true }
];